import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filter",
  standalone: true,
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string | number, property: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    if (typeof searchText === "string") searchText = searchText.toLowerCase();

    return items.filter(it => {
      return it[property]?.toString()?.toLowerCase().includes(searchText);
    });
  }
}
